import { handleActions } from 'redux-actions';

import { types, inputFieldNames } from '../constants';

const INITIAL_STATE = {
  newUser: {
    showCreateUserDialog: false,
    showEditUserDialog: false,
    showDeleteUserDialog: false,
    item: {
      role: 0,
      branchId: 0
    },
    isSaving: false,
    errorMessage: ''
  },
  user: {
    item: null,
    isLoading: false,
    errorMessage: ''
  }
};

const openCreateUserDialog = (state, { open }) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      showCreateUserDialog: open,
      item: {}
    }
  };
};

const openEditUserDialog = (state, { open }) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      showEditUserDialog: open,
      item: {}
    }
  };
};

const openDeleteUserDialog = (state, { open }) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      showDeleteUserDialog: open,
      item: {},
      errorMessage: ''
    }
  };
};

const startSubmitUser = (state) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      isSaving: true
    }
  };
};
const submitUserSuccess = (state, { submittedUser }) => {
  return {
    ...state,
    user: {
      ...state.user,
      item: submittedUser
    }
  };
};
const submitUserFailure = (state, { errorMessage }) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      errorMessage
    }
  };
};
const submitUserFinished = (state) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      isSaving: false
    }
  };
};

const inputChangeCreateUserForm = (state, { value, inputFieldName }) => {
  const user = { ...state.newUser.item };
  if (inputFieldName === inputFieldNames.USER_NAME) {
    user.name = value;
  } else if (inputFieldName === inputFieldNames.USER_EMAIL) {
    user.email = value;
  } else if (inputFieldName === inputFieldNames.USER_ROLE) {
    user.role = value;
  } else if (inputFieldName === inputFieldNames.USER_BRANCH) {
    user.branchId = parseInt(value);
  } else if (inputFieldName === inputFieldNames.USER_COMPANY) {
    user.companyId = parseInt(value);
  } else if (inputFieldName === inputFieldNames.USER_PASSWORD) {
    user.password = value;
  }

  return {
    ...state,
    newUser: {
      ...state.newUser,
      item: user
    }
  };
};

const editUser = (state, { user }) => {
  return {
    ...state,
    newUser: {
      ...state.newUser,
      item: user
    }
  };
};

export default handleActions(
  {
    [types.OPEN_CREATE_USER_DIALOG]: openCreateUserDialog,
    [types.OPEN_EDIT_USER_DIALOG]: openEditUserDialog,
    [types.OPEN_DELETE_USER_DIALOG]: openDeleteUserDialog,

    [types.START_SUBMIT_USER]: startSubmitUser,
    [types.SUBMIT_USER_SUCCESS]: submitUserSuccess,
    [types.SUBMIT_USER_FAILURE]: submitUserFailure,
    [types.SUBMIT_USER_FINISHED]: submitUserFinished,

    [types.INPUT_CHANGE_CREATE_USER_FORM]: inputChangeCreateUserForm,

    [types.EDIT_USER]: editUser
  },
  INITIAL_STATE
);
